module.exports = __webpack_public_path__ + "img/react.c4eb3d0b.jpg";